define("shared/components/shared/color-picker/selector", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @class="cLB--stylePreview {{@qaClass}}"
    @onClick={{@onClick}}
    @variant="unstyled"
    data-test-id="selector"
    id={{@id}}
  >
    <span class="cLB--stylePreview__color" data-test-swatch-id={{@color}} {{style color=@color}}>
    </span>
    <span class="cLB--stylePreview__label cLB--stylePreview__label--customize" data-test-title-id={{@color}}>
      {{@color}}
    </span>
  </Shared::Ui::Button>
  */
  {
    "id": "vrcnfQFy",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"selector\"],[16,1,[30,1]]],[[\"@class\",\"@onClick\",\"@variant\"],[[29,[\"cLB--stylePreview \",[30,2]]],[30,3],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n  \"],[11,1],[24,0,\"cLB--stylePreview__color\"],[16,\"data-test-swatch-id\",[30,4]],[4,[38,1],null,[[\"color\"],[[30,4]]]],[12],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,1],[14,0,\"cLB--stylePreview__label cLB--stylePreview__label--customize\"],[15,\"data-test-title-id\",[30,4]],[12],[1,\"\\n    \"],[1,[30,4]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@id\",\"@qaClass\",\"@onClick\",\"@color\"],false,[\"shared/ui/button\",\"style\"]]",
    "moduleName": "shared/components/shared/color-picker/selector.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});